/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, Project } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class ShapefileDataService extends HttpBaseService {

    route = environment.api + 'shapefile/apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getSitesGeoJsonFile(app: App, project: Project, formData: FormData): Observable<string> {
        const url = `${this.route}${app.id}/projects/${project.id}/convert`;
        return this.httpPost(url, formData);
    }
}
